import { useReducer } from "react";
import AppStateReducer from "./AppStateReducer";
import StateFonts from "./Finders/StateFonts.js";

const useAppState = () => {
  const [state, dispatch] = useReducer(AppStateReducer, {});
  return {
    state: {
      get: (query) => {
        try {
          return StateFonts(state, query);
        } catch (e) {
          return null;
        }
      },
      set: (param) => {
        return dispatch(['state', param]);
      },
    }
  }
};

export default useAppState;
